(ns frontend.view.components.form.components.form-label
  (:require
   [reagent.core :as r]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]))

(defn view
  [_]
  (fn [{:keys [label info mandatory? error? extra-builder hide-labels? value intelligence-value]}]
    (when-not hide-labels?
      (let [tooltip (r/as-element
                     [rbs/Tooltip
                      {:id        "tooltip"
                       :placement "top"
                       :class     "in"}
                      info])]
        [rbs/FormLabel
         {:class-name (fu/cs :zap-label)}
         (when (and intelligence-value
                    (or (not value)
                        (and (string? value)
                             (empty? value))))
           [:img
            {:class-name "intelligence-icon"
             :src        "/img/favicon256x256.ico"}])
         [:div.label__container
          label (when mandatory? [:span.mandatory " *"])]

         (when extra-builder
           (extra-builder))
         (when error?
           [:i.fal.fa-lg.fa-exclamation-circle.error])
         (when info
           [rbs/OverlayTrigger
            {:placement     "top"
             :popper-config {:modifiers [{:name    "preventOverflow"
                                          :options {:main-axis false}}
                                         {:name "hide"}]}
             :overlay       tooltip}
            [:i.fal.fa-info-circle
             {:style       {:float "right"}
              :aria-hidden true}]])]))))
